import repository from '@/api'
import ManualArticle from '@/models/ManualArticle'

const URI = `/v1/manuals`
export default {
  findManualByManualNo(manualNo, viewType?: 'TreeChart' | 'ListView') {
    return repository.get<Manual>(`${URI}/${manualNo}?viewType=${viewType || 'TreeChart'}`)
  },
  modifyManual(manualId, { headings }) {
    return repository.patch(`${URI}/${manualId}`, { headings })
  },
}

type Manual = {
  manualId: string
  manualNo: string
  name: string
  description?: string
  treeChart?: {
    headings: Heading[]
  }
  editable: boolean
  superuser: boolean
}

type Heading = {
  headingId: string
  pageNo?: string
  level?: number
  name?: string
  subHeadings?: Heading[]
  articles?: ManualArticle[]
}
